import { sagas as list } from './list';
import { sagas as create } from './create';
import { sagas as update } from './update';
import { sagas as remove } from './remove';
import { sagas as tabs } from './tabs';

export default [
  ...list,
  ...create,
  ...update,
  ...remove,
  ...tabs,
];
